import { render, staticRenderFns } from "./HostAfricaSplaPackagePrices.vue?vue&type=template&id=bac6bc1e&"
import script from "./HostAfricaSplaPackagePrices.vue?vue&type=script&lang=js&"
export * from "./HostAfricaSplaPackagePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports